export default "__VITE_ASSET__2ab1ecce__"